import React, { Component } from 'react';
import { Card, Cell, Grid } from 'react-md';

import './MapLegend.scss';

class MapLegend extends Component {
  render() {
    return (
      <div className="maplegend-container md-grid mobile-fix">
        <Card className="md-block-centered">
          <Grid className="legend-grid">
            <Cell size={3} className="legend-icon-cell">
              <svg height="40" width="40">
                <circle cx="20" cy="20" r="10" fill="#00FFD3" opacity="0.75" />
                <circle cx="20" cy="20" r="15" fill="#00FFD3" opacity="0.25" />
              </svg>
            </Cell>
            <Cell size={9} className="legend-text-cell">
              <div className="legend-text">
                Largest sources of compromised devices connecting to server-side
                APIs (represented by HQ)
              </div>
            </Cell>

            <Cell size={3} className="legend-icon-cell">
              <svg height="25" width="40">
                <circle cx="20" cy="12" r="6" fill="#FFBEBA" opacity="1.0" />
              </svg>
            </Cell>
            <Cell size={9} className="legend-text-cell">
              <div className="legend-text">
                Eavesdropping attacks (Intercepted SSL/TLS request)
              </div>
            </Cell>

            <Cell size={3} className="legend-icon-cell">
              <svg height="25" width="40">
                <rect height="3" width="32" x="6" y="11" fill="#FF0000" />
              </svg>
            </Cell>
            <Cell size={9} className="legend-text-cell">
              <div className="legend-text">
                Network connections between mobile apps and server side APIs
              </div>
            </Cell>
          </Grid>
        </Card>
      </div>
    );
  }
}

export default MapLegend;



// WEBPACK FOOTER //
// ./src/components/MapLegend/MapLegend.jsx